import { Customer } from 'lmcv/pages/Customer'
import { Faq } from 'lmcv/pages/Faq'
import { Home } from 'lmcv/pages/NewHome'
import { AdvantagesPage } from 'lmcv/pages/AdvantagesPage'
import { JoinProgram } from 'lmcv/pages/JoinProgram'
import { MyPointsPage } from 'lmcv/pages/MyPoints'
import { MyPointsPagePro } from 'lmcv/pages/MyPointsPro'
import { Professional } from 'lmcv/pages/Professional'
import { CustomersPage } from 'lmcv/pages/Customers'
import { ExchangePage } from 'lmcv/pages/ExchangePage'

import RenderRoutes from './components/RenderRoutes'

const ROUTES = [
  {
    path: '/faca-parte',
    key: 'OUTSIDE_OF_PROGRAM',
    exact: true,
    privated: false,
    component: JoinProgram
  },
  {
    path: '/',
    key: 'HOME',
    exact: true,
    privated: true,
    component: Home
  },
  {
    path: '/meus-pontos',
    key: 'MY_POINTS',
    exact: true,
    privated: true,
    component: MyPointsPage
  },
  {
    path: '/pro-meus-pontos',
    key: 'PRO_MY_POINTS',
    exact: true,
    privated: true,
    component: MyPointsPagePro
  },
  {
    path: '/minhas-vantagens',
    key: 'ADVANTAGES_PAGE',
    exact: true,
    privated: true,
    component: AdvantagesPage
  },
  {
    path: '/troque',
    key: 'MONEY_PAGE',
    exact: true,
    privated: true,
    component: props => <ExchangePage {...props} voucherType="money" />
  },
  {
    path: '/clientes',
    key: 'CUSTOMERS_PAGE',
    exact: true,
    privated: true,
    component: CustomersPage
  },
  {
    path: '/cliente/:id',
    key: 'CUSTOMER_PAGE',
    exact: true,
    privated: true,
    component: Customer
  },
  {
    path: '/duvidas',
    key: 'FAQ',
    exact: true,
    privated: true,
    component: Faq
  },
  {
    path: '/profissional/:id',
    key: 'PROFESSIONAL_PAGE',
    exact: true,
    privated: true,
    component: Professional
  }
]

export { ROUTES, RenderRoutes }
